import { CROP_EMOJIS } from './constants';

export const formatPrice = (price) => {
  if (price === null || price === undefined || isNaN(price)) return '₹—';
  return `₹${Number(price).toLocaleString('en-IN')}/qtl`;
};

export const formatPriceKg = (price) => {
  if (price === null || price === undefined || isNaN(price)) return '₹—';
  return `₹${Number(price).toLocaleString('en-IN')}/kg`;
};

export const formatDate = (timestamp) => {
  if (!timestamp) return '—';
  try {
    let date;
    if (timestamp?.toDate) {
      date = timestamp.toDate();
    } else if (timestamp?.seconds) {
      date = new Date(timestamp.seconds * 1000);
    } else {
      date = new Date(timestamp);
    }
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return '—';
  }
};

export const formatDateTime = (timestamp) => {
  if (!timestamp) return '—';
  try {
    let date;
    if (timestamp?.toDate) {
      date = timestamp.toDate();
    } else if (timestamp?.seconds) {
      date = new Date(timestamp.seconds * 1000);
    } else {
      date = new Date(timestamp);
    }
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '—';
  }
};

export const formatTimeAgo = (timestamp) => {
  if (!timestamp) return '';
  let date;
  if (timestamp?.toDate) {
    date = timestamp.toDate();
  } else if (timestamp?.seconds) {
    date = new Date(timestamp.seconds * 1000);
  } else {
    date = new Date(timestamp);
  }

  const now = new Date();
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'अभी';
  if (diffMins < 60) return `${diffMins} मिनट पहले`;
  if (diffHours < 24) return `${diffHours} घंटे पहले`;
  if (diffDays < 7) return `${diffDays} दिन पहले`;
  return formatDate(timestamp);
};

export const getPriceChangePercent = (oldPrice, newPrice) => {
  if (!oldPrice || oldPrice === 0) return 0;
  return parseFloat((((newPrice - oldPrice) / oldPrice) * 100).toFixed(2));
};

export const getSeasonFromMonth = (month) => {
  // month is 0-indexed (0=Jan, 11=Dec)
  if (month >= 5 && month <= 9) return 'Kharif';  // Jun-Oct
  if (month >= 10 || month <= 3) return 'Rabi';    // Nov-Apr
  return 'Zaid';                                    // Mar-Jun
};

export const getCurrentSeason = () => {
  const month = new Date().getMonth();
  return getSeasonFromMonth(month);
};

export const getCropEmoji = (cropName) => {
  if (!cropName) return '🌿';
  return CROP_EMOJIS[cropName] || CROP_EMOJIS[cropName.trim()] || '🌿';
};

export const getPriceChangeColor = (change) => {
  if (change > 0) return '#2E7D32';
  if (change < 0) return '#C62828';
  return '#757575';
};

export const getPriceChangeIcon = (change) => {
  if (change > 0) return '↑';
  if (change < 0) return '↓';
  return '→';
};

export const truncateText = (text, length = 100) => {
  if (!text) return '';
  if (text.length <= length) return text;
  return text.substring(0, length) + '...';
};

export const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

export const maskPhone = (phone) => {
  if (!phone) return '—';
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10) return phone;
  return `+91 ${digits.slice(-10, -6)}****${digits.slice(-2)}`;
};

export const formatNumber = (num) => {
  if (!num) return '0';
  if (num >= 10000000) return `${(num / 10000000).toFixed(1)} Cr`;
  if (num >= 100000) return `${(num / 100000).toFixed(1)} L`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
};

export const validatePhone = (phone) => {
  const digits = phone.replace(/\D/g, '');
  return digits.length === 10 && /^[6-9]/.test(digits);
};

export const formatPhoneWithCode = (phone) => {
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('91') && digits.length === 12) return `+${digits}`;
  if (digits.length === 10) return `+91${digits}`;
  return `+91${digits}`;
};

export const getWeatherIcon = (condition) => {
  if (!condition) return '⛅';
  const c = condition.toLowerCase();
  if (c.includes('clear') || c.includes('sunny')) return '☀️';
  if (c.includes('cloud') && c.includes('partly')) return '⛅';
  if (c.includes('cloud') || c.includes('overcast')) return '☁️';
  if (c.includes('rain') || c.includes('shower')) return '🌧️';
  if (c.includes('thunder') || c.includes('storm')) return '⛈️';
  if (c.includes('snow')) return '❄️';
  if (c.includes('fog') || c.includes('mist')) return '🌫️';
  if (c.includes('haze')) return '🌤️';
  if (c.includes('wind')) return '💨';
  return '⛅';
};

export const kelvinToCelsius = (k) => Math.round(k - 273.15);

export const generateCSV = (data, headers) => {
  const csvRows = [];
  csvRows.push(headers.join(','));
  data.forEach(row => {
    const values = headers.map(h => {
      const val = row[h.key || h] || '';
      return `"${String(val).replace(/"/g, '""')}"`;
    });
    csvRows.push(values.join(','));
  });
  return csvRows.join('\n');
};

export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const getTimestampDate = (timestamp) => {
  if (!timestamp) return null;
  if (timestamp?.toDate) return timestamp.toDate();
  if (timestamp?.seconds) return new Date(timestamp.seconds * 1000);
  return new Date(timestamp);
};
